import {
  BOOKING_CHECKOUT_DRAFT_TTL_MS,
  BOOKING_CHECKOUT_DRAFT_VERSION,
  BookingCheckoutDraft,
  StoredBookingCheckoutEnvelope,
} from '@core/models/booking-checkout.types';

export const BOOKING_CHECKOUT_STORAGE_KEY = 'bookingCheckoutDraft';

const LEGACY_STORAGE_KEYS = ['bookingDetail'] as const;

export function isCheckoutDraftExpired(updatedAt: number, now = Date.now()): boolean {
  return now - updatedAt > BOOKING_CHECKOUT_DRAFT_TTL_MS;
}

export function toStoredEnvelope(draft: BookingCheckoutDraft): StoredBookingCheckoutEnvelope {
  const {version, updatedAt, ...rest} = draft;
  return {
    version,
    updatedAt,
    draft: rest,
  };
}

export function fromStoredEnvelope(raw: unknown, now = Date.now()): BookingCheckoutDraft | null {
  if (!raw || typeof raw !== 'object') {
    return null;
  }
  const envelope = raw as StoredBookingCheckoutEnvelope;
  if (envelope.version !== BOOKING_CHECKOUT_DRAFT_VERSION) {
    return null;
  }
  if (typeof envelope.updatedAt !== 'number' || isCheckoutDraftExpired(envelope.updatedAt, now)) {
    return null;
  }
  if (!envelope.draft?.charger?.id || envelope.draft.connectorNo == null) {
    return null;
  }
  return {
    version: BOOKING_CHECKOUT_DRAFT_VERSION,
    updatedAt: envelope.updatedAt,
    ...envelope.draft,
  };
}

export function legacyStorageKeysToRemove(): readonly string[] {
  return LEGACY_STORAGE_KEYS;
}
